import('./bootstrap').then((bootstrap) => bootstrap.default());
